import { Loader2 } from 'lucide-react';
import {
  onboardingPrimaryButtonClass,
  onboardingSecondaryButtonClass,
  onboardingSpinnerClass,
} from './onboarding_styles';
import { PartnerTermsText } from './PartnerTermsText';

interface OnboardingStepTermsProps {
  accepted: boolean;
  onAcceptedChange: (accepted: boolean) => void;
  onBack: () => void;
  onContinue: () => void;
  continueLabel: string;
  busy?: boolean;
  error?: string | null;
}

/**
 * Step 2 — the NDA and terms of service, with the accept checkbox that unlocks
 * Continue.
 *
 * The agreement is the reason this wizard blocks the site rather than nagging
 * from a banner: it governs what a partner may do with what they are about to
 * see, so it has to be answered before they see any of it.
 */
export function OnboardingStepTerms({
  accepted,
  onAcceptedChange,
  onBack,
  onContinue,
  continueLabel,
  busy,
  error,
}: OnboardingStepTermsProps) {
  return (
    <div className='ed-step-content'>
      <div className='tw:mb-6'>
        <h2 className='tw:mb-2 tw:font-serif tw:text-2xl tw:text-white'>Terms &amp; Agreement</h2>
        <p className='tw:text-sm tw:text-white/50'>Please review and accept our terms</p>
      </div>

      <div className='ed-terms-scroll tw:mb-6 tw:rounded-sm tw:bg-black/30 tw:p-6 tw:text-sm tw:leading-relaxed'>
        <PartnerTermsText />
      </div>

      <div className='tw:mb-6 tw:flex tw:items-start tw:gap-4'>
        <input
          type='checkbox'
          id='agree-terms'
          checked={accepted}
          disabled={busy}
          onChange={(e) => onAcceptedChange(e.target.checked)}
          className='tw:mt-1 tw:size-5 tw:cursor-pointer tw:accent-ed-gold'
        />
        <label htmlFor='agree-terms' className='tw:cursor-pointer tw:text-sm tw:text-white/70'>
          I have read and agree to the Non-Disclosure Agreement and Terms of Service.
        </label>
      </div>

      {error && <p className='tw:mb-6 tw:text-sm tw:text-ed-red'>{error}</p>}

      <div className='tw:flex tw:gap-4'>
        <button type='button' onClick={onBack} disabled={busy} className={onboardingSecondaryButtonClass}>
          Back
        </button>
        <button
          type='button'
          onClick={onContinue}
          disabled={!accepted || busy}
          aria-busy={busy || undefined}
          className={onboardingPrimaryButtonClass}
        >
          {busy && <Loader2 className={onboardingSpinnerClass} />}
          {busy ? 'Saving…' : continueLabel}
        </button>
      </div>
    </div>
  );
}
